import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { ERROR_CODE } from 'src/app/core/properties/application.properties';
import { ToastService } from 'src/app/shared/components/toast/services/toast.service';
import { TOAST_TYPE } from 'src/app/shared/components/toast/enums/toast.enum';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  constructor(private toastService: ToastService) {}

  handle(error: HttpErrorResponse) {
    if (error.status === 401 || error.status > 500) {
      // Temporary Check - error
      this.toastService.showToast({
        severity: TOAST_TYPE.ERROR,
        detail: ERROR_CODE[error.status] ?? ERROR_CODE['DEFAULT'],
      });
    }
  }
}
